import React, { useState, useEffect, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import MeetingData from 'components/brandActivation/viewDetails/meetingData/meetingData';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const MeetingDetails = ({
  getMeetingById,
  meetingById,
  cancelMeeting,
  completeMeeting,
  match,
  history,
}) => {
  const [details, setDetails] = useState(null);
  const [poc, setPoc] = useState([]);
  const [othersEmail, setOthersEmail] = useState([]);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [isCompleteModal, setIsCompleteModal] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [contractPoc, setContractPoc] = useState([]);

  console.log("TESRGBS: ", meetingById);

  useEffect(() => {
    (async () => {
      if (match?.params?.id) {
        setIsLoading(true);
        await getMeetingById(match?.params?.id);
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    setDetails(null);
    if (meetingById?.meeting) {
      setDetails(meetingById.meeting);
    }
    if (meetingById?.poc) {
      setPoc(meetingById.poc);
    }
    if (meetingById?.others_email?.length > 0) {
      setOthersEmail(meetingById.others_email);
    }
    if(meetingById?.payment_data) {
      setPaymentData(meetingById?.payment_data);
    }
    if(meetingById?.contract_poc_details?.length > 0) {
      setContractPoc(meetingById?.contract_poc_details)
    }
  }, [meetingById]);

  const handleModalHide = () => setIsModal(false);

  const handleCancelModalHide = () => {
    setIsCancelModal(false);
    history.goBack();
  };

  const handleCancel = async () => {
    (async () => {
      setIsLoading(true);
      const res = await cancelMeeting(match?.params?.id);
      setIsLoading(false);
      if (res === true) {
        setIsCancelModal(true);
      }
    })();
  };

  const handleCompleteModalHide = () => {
    setIsCompleteModal(false);
    history.goBack();
  };

  const handleComplete = async () => {
    (async () => {
      setIsLoading(true);
      const res = await completeMeeting(match?.params?.id);
      setIsLoading(false);
      if (res) {
        setIsCompleteModal(true);
      }
    })();
  };

  // const headerBtns = () => {
  //   return (
  //     <Fragment>
  //       {details !== null && details?.mom_send_status !== null && (
  //         <Link
  //           to={
  //             details.mom_send_status === 0
  //               ? `${baseUrl}/brand-activation/create-minutes-of-meeting/${match?.params?.id}`
  //               : `${baseUrl}/brand-activation/view-minutes-of-meeting/${match?.params?.id}`
  //           }
  //           className="btn btn-primary"
  //         >
  //           {details.mom_send_status === 0
  //             ? localization.createMom
  //             : localization.viewMom}
  //           <img src={Images?.ArrowRight} alt="" />
  //         </Link>
  //       )}
  //     </Fragment>
  //   );
  // };

  return (
    <Layout
      title={localization.scheduleMeeting}
      // Buttons={
      //   details !== null &&
      //   details.mom_send_status === 0 &&
      //   (details.status === 'Cancelled' || details.status === 'Completed')
      //     ? null
      //     : headerBtns
      // }
      isGoback
      isLoading={isLoading}
      linkFlag
      // linkUrl={`${baseUrl}/brand-activation/scheduled-meetings/${match?.params?.id}`}
      linkUrl={`${baseUrl}/brand-activation/scheduled-meeting`}
    >
      <div>
        {details && Object.keys(details).length !== 0 ? (
          <MeetingData details={details} poc={poc} othersEmail={othersEmail} paymentData={paymentData} contractPoc={contractPoc} />
        ) : null}
        {/* {details !== null &&
        (details.status === 'Cancelled' ||
          details.status === 'Completed') ? null : (
          <div className="form-group btn-group d-xs-flexflow-wrap pad-0">
            <Button className="btn btn-transparent" onClick={handleCancel}>
              {localization.cancelMeeting}
            </Button>

            <Button className="btn btn-transparent" onClick={handleComplete}>
              {localization.markComplete}
            </Button>

            <Link
              to={`${baseUrl}/brand-activation/reschedule-a-meeting/${details?.site_id}/${match?.params?.id}`}
              className="btn btn-primary"
            >
              {localization.rescheduleMeeting}
            </Link>
          </div>
        )} */}
      </div>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingSuccess}</h5>
          <Link
            to={`${baseUrl}/brand-activation/scheduled-meetings/${match?.params?.id}`}
            className="btn btn-primary mb-4"
          >
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      {/* Cancel Meeting PopUp */}
      <ModalPop
        title={localization.conf}
        show={isCancelModal}
        handleModalHide={handleCancelModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingCancelSuccess}</h5>
          <Button
            onClick={handleCancelModalHide}
            className="btn btn-primary mb-4"
          >
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
      {/* Cancel Meeting PopUp */}
      <ModalPop
        title={localization.conf}
        show={isCompleteModal}
        handleModalHide={handleCompleteModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingMarkedCompleted}</h5>
          <Button
            onClick={handleCompleteModalHide}
            className="btn btn-primary mb-4"
          >
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default MeetingDetails;
